import { useContext, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ASSET_HOST_BASE_URL } from "../../../config";
import LangContext from "../../../contexts/LangContext";
import { translate } from "../../../helper";
import "./index.css";

const Footer = (props) => {
  const { lang } = useContext(LangContext);
  const [active, setActive] = useState("home");
  const cyear = new Date().getFullYear();
  const urlParams = new URLSearchParams(window.location.search);
  let type = urlParams.get("type");
  type = props.tab ? props.tab : type;

  const handleLinkClick = (item) => {
    setActive(item);
  };

  useEffect(() => {
    const path = window.location.pathname;
    if (path.includes("/parties")) {
      setActive("parties");
    } else if (path.includes("/candidates")) {
      setActive("candidates");
    } else if (path.includes("/heavy-weights")) {
      setActive("heavy-weights");
    } else if (path.includes("/result")) {
      setActive("home");
    } else {
      setActive("home");
    }
  }, []);

  return (
    <section className="sh-footer-section">
      <footer id="footer">
        <div className="container sh-footer-inner">
          <div className="sh-company-logo">
            <a href={"/?type=" + props.tab + "&lang=" + lang} className="sh-footer-logo-link">
              <img src={ASSET_HOST_BASE_URL + "/images/logo_variation.png"} alt="DeshSanchar" />
            </a>
          </div>

          <ul className="sh-quick-links">
            <li id="li-home">
              <Link
                to={"/result/?type=" + props.tab + "&lang=" + lang}
                onClick={() => handleLinkClick("home")}
                className={active === "home" ? "active" : ""}
              >
                {translate("homepage", lang)}
              </Link>
            </li>
            <li id="li-candidates">
              <Link
                to={"/candidates?type=" + type + "&lang=" + lang}
                onClick={() => handleLinkClick("candidates")}
                className={active === "candidates" ? "active" : ""}
              >
                {translate("candidate", lang)}
              </Link>
            </li>
            <li id="li-heavy-weights">
              <Link
                to={"/heavy-weights?type=" + type + "&lang=" + lang}
                onClick={() => handleLinkClick("heavy-weights")}
                className={active === "heavy-weights" ? "active" : ""}
              >
                {translate("heavy_weights", lang)}
              </Link>
            </li>
            <li id="li-parties">
              <Link
                to={"/parties?lang=" + lang}
                onClick={() => handleLinkClick("parties")}
                className={active === "parties" ? "active" : ""}
              >
                {translate("parties", lang)}
              </Link>
            </li>
          </ul>

          <ul className="sh-social-links">
            <li>
              <a target="_blank" rel="noreferrer" href="https://www.facebook.com/deshsanchar1">
                <img src={ASSET_HOST_BASE_URL + "/images/ic_facebook.png"} alt="Facebook" />
              </a>
            </li>
            <li>
              <a target="_blank" rel="noreferrer" href="https://twitter.com/deshsanchar1">
                <img src={ASSET_HOST_BASE_URL + "/images/ic_twitter.png"} alt="Twitter" />
              </a>
            </li>
            <li>
              <a target="_blank" rel="noreferrer" href="https://www.instagram.com/deshsanchar">
                <img src={ASSET_HOST_BASE_URL + "/images/ic_instagram.png"} alt="Instagram" />
              </a>
            </li>
            <li>
              <a target="_blank" rel="noreferrer" href="https://www.youtube.com/channel/UCbj1uYp-Z_YjyU4fQ0OYDCg/featured">
                <img src={ASSET_HOST_BASE_URL + "/images/ic_youtube.png"} alt="Youtube" />
              </a>
            </li>
          </ul>

          {/* <div className="sh-sub-links text-center">
            <button value="np" className={lang === "np" ? "sh-lang-btn-active" : "sh-lang-btn"} onClick={props.handleLanguageChange}>
              नेपाली
            </button>
            <button value="en" className={lang === "en" ? "sh-lang-btn-active" : "sh-lang-btn"} onClick={props.handleLanguageChange}>
              English
            </button>
          </div> */}
        </div>

        <div className="sh-copyright">
          <p>Copyright © 2017 - {cyear} Deshsanchar Pvt. Ltd</p>
        </div>
      </footer>
    </section>
  );
};

export default Footer;
